// components/NearbyDeviceList.js
import React from "react";
const NearbyDeviceList = ({ devices, onConnect, onDisconnect, connectedCamera }) => {
    return (
      <div>
        {devices.map((device, index) => {
          const isConnected = connectedCamera === device.device_id;
          const isAvailable = !device.inUse || isConnected;
  
          return (
            <div
              key={index}
              style={{
                marginBottom: "10px",
                padding: "10px",
                backgroundColor: "#fff",
                border: "1px solid #dee2e6",
                borderRadius: "6px",
              }}
            >
                
              <div><strong>ID:</strong> {device.device_id}</div>
              <div><strong>Distance:</strong> {device.distance?.toFixed(2)}m</div>
  
              <div
                style={{
                  marginTop: "8px",
                  padding: "6px 10px",
                  borderRadius: "4px",
                  backgroundColor: isConnected
                    ? "#4caf50"
                    : device.inUse
                    ? "#f44336"
                    : "#e0e0e0",
                  color: isConnected || device.inUse ? "#fff" : "#000",
                  display: "inline-block"
                }}
              >
                <strong>Status:</strong> {isConnected ? "Connected" : device.inUse ? "In Use" : "Available"}
              </div>
  
              {isAvailable && (
                <button
                  onClick={() => isConnected ? onDisconnect(device.device_id) : onConnect(device.device_id)}
                  style={{
                    marginTop: "10px",
                    padding: "6px 12px",
                    backgroundColor: isConnected ? "#f44336" : "#4caf50",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    display: "block"
                  }}
                >
                  {isConnected ? "Disconnect" : "Connect"}
                </button>
              )}
            </div>
          );
        })}
      </div>
    );
  };
export default NearbyDeviceList;
